<template>
    <div class="standard sidebar">
        <div class="ui secondary vertical menu"
            data-step="1"
            data-position='right'
            data-intro="歡迎來到客戶端">

            <nav>
                <router-link :to="{name: 'customer_index'}">
                    <img class="ui image"
                        :src="'/images/'+service_config.logo_img">
                </router-link>

                <a class="hamburger hamburger--spin"
                    @click="toggle_menu()"
                >
                    <span class="hamburger-box">
                        <span class="hamburger-inner"></span>
                    </span>
                </a>
            </nav>
            <div class="ui divider"></div>

            <div class="nav-menu">
                <router-link :to="{name: 'customer_operations'}" class="item">
                    <i class="icons">
                        <i class="file large icon"></i>
                        <span> {{ $t('ui.links.menu.provider_operations') }} </span>
                    </i>
                </router-link>
                <router-link :to="{name: 'customer_uploader'}" class="item">
                    <i class="icons">
                        <i class="upload large icon"></i>
                        <span> {{ $t('ui.links.menu.uploader') }} </span>
                    </i>
                </router-link>
                <router-link :to="{name: 'customer_core_waybills'}" class="item">
                    <i class="icons">
                        <i class="archive large icon"></i>
                        <span> {{ $t('ui.links.menu.core_waybills') }} </span>
                    </i>
                </router-link>
            </div>

            <!-- <div class="nav-menu">
                <router-link :to="{name: 'customer_partitions'}" class="item">
                    <i class="icons">
                        <i class="sort numeric ascending large icon"></i>
                        <span> 號碼區間 </span>
                    </i>
                </router-link>
            </div> -->
        </div>
    </div>
</template>

<script>
    export default {
        props: {
        },
        data() {
            return {
            }
        },
        computed: {
            service_config() {
                return this.$store.state.customer.service_config
            },
        },
        watch: {
            '$route'(to, from) {
                this.menu_active()

                if (
                    (767 > $(window).width()) &&
                    ($(".nav-menu").css("display") == "block")
                ) {
                    this.toggle_menu()
                }
            },
        },
        mounted() {
            this.menu_active()

            $(window).resize(() => {
                var wdth = $(window).width()
                var nav_menu_display = $(".nav-menu").css("display")
                if (nav_menu_display == 'none' && wdth > 767) {
                    $(".nav-menu").css("display", "block")
                }
            })
        },
        methods: {
            menu_active() {
                $(".nav-menu a.item").each(() => {
                    $(this).removeClass("active")
                    if (window.location.href.includes(this.href) ) {
                        $(this).addClass("active")
                    }
                })
            },
            toggle_menu() {
                $("body").toggleClass("overflow")
                $(".hamburger").toggleClass("active")
                $(".nav-menu").stop().slideToggle(300)
            },
        },
    }
</script>


<style lang="scss">
    @import "../../../assets/stylesheets/sidebar.scss";
</style>
